<template>
  <div id="app">
    <MemoryGame />
  </div>
</template>

<script>
import MemoryGame from './components/MemoryGame.vue'

export default {
  name: 'App',
  components: {
    MemoryGame
  },
  data() {
    return {
    
    }
  },
  methods: {
  
  }
}
</script>

<style lang="scss">
@import url(./assets/css/style.css);
</style>
